export const SHARED_MUTATIONS = [];

export default {};
